// extracted by mini-css-extract-plugin
export default {"container":"k0-z","heading":"l0-z","links":"m0-z","copy":"n0-z","subCopy":"o0-z","linksLeft":"p0-z","linksCenter":"q0-z","linksRight":"r0-z","link":"s0-z","onlyLink":"t0-z"};